
//-----------------------------------------------------------------------------------

import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../../context/UserContext';
import { CartContext } from '../../context/CartContext';
import axios from 'axios';



const Login = () => {

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState(false);
  const { setCart } = useContext(CartContext);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useContext(UserContext);

  const notify = () => toast();

  const handleLogin = async () => {
    setStatus(true);
    notify();

    if (email === "") {
      toast.error("Please enter your email!");
      setStatus(false);
      return;
    }

    if (password === "") {
      toast.error("Please enter your password!");
      setStatus(false);
      return;
    }

    try {
      const response = await login(email, password);
      const message = response.data.message;
      const status = response.data.status;

      if (status === "error") {
        setStatus(false);
        toast.warn(message);
      } else {
        localStorage.setItem('token', response.data.token); // Store the token in local storage
        localStorage.setItem('userType', response.data.userType); // Store the token in local storage
        setCart([]);
        navigate('/'); // Navigate to home page after successful login
        getCartData();
      }

    } catch (err) {
      console.error('Error logging in:', err.response ? err.response.data : err.message);
      setStatus(false);
      toast.error("Error logging in the user!");
    }
  };


  const getCartData = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}cart`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setCart(response.data);
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Fetch cart data after login
      getCartData();
    }
  }, []);





  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="container-fluid Login-section">
      <div className="login-form bg-light shadow p-4 rounded">
        <h6 className="mb-3 fw-bold text-muted">
          <Icon.Lock className="me-2" />
          Login
        </h6>

        {/* Email Input */}
        <div className="mb-3">
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            className="form-control shadow-none"
            id="loginEmail"
            placeholder="Email"
          />
        </div>

        {/* Password Input */}
        <div className="mb-3 position-relative">
          <input
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            className="form-control shadow-none"
            id="loginPassword"
            placeholder="Password"
          />
          {/* Toggle Eye Icons */}
          <Icon.EyeSlashFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={showPassword ? 'd-none' : ''}
          />
          <Icon.EyeFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={!showPassword ? 'd-none' : ''}
          />
        </div>

        {/* Login Button */}
        <div className="w-100 d-flex justify-content-between align-items-center mt-4">
          {status ? (
            <button className="btn btn-success w-50" disabled>
              <span
                className="spinner-border spinner-border-sm me-2"
                aria-hidden="true"
              ></span>
              <span role="status">Logging in...</span>
            </button>
          ) : (
            <button onClick={handleLogin} className="btn btn-success w-50">
              Login
            </button>
          )}
          <ToastContainer theme="dark" autoClose={2000} />
          <Link to="/signup" className="nav-link">
            Sign Up
            <Icon.BoxArrowRight className="ms-2" />
          </Link>
        </div>

        {/* Forgot Password Link */}
        <div
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Link
            to="/forgotpassword"
            style={{
              textDecoration: 'none',
              color: '#007bff',
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
            }}
          >
            Forgot Password?
            <Icon.BoxArrowRight style={{ marginLeft: '5px' }} />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;

